import React from "react";

/* eslint-disable max-len */
export default function cineonhubIcon() {
    return (
        <svg
            id="\u30B0\u30EB\u30FC\u30D7_9"
            data-name="\u30B0\u30EB\u30FC\u30D7 9"
            xmlns="http://www.w3.org/2000/svg"
            width={158.705}
            height={28.67}
            viewBox="0 0 158.705 28.67"
        >
            <defs>
                <style>{".cls-1{fill:#fff}.cls-2{fill:#12e07e}"}</style>
            </defs>
            <path
                id="\u30D1\u30B9_64"
                data-name="\u30D1\u30B9 64"
                className="cls-1"
                d="M260.609 471.04a7.161 7.161 0 00-14.322 0V485.381h3.613v-14.414a3.545 3.545 0 017.089 0v14.414h3.617v-14.323z"
                transform="translate(-218.154 -456.821)"
            />
            <path
                id="\u30D1\u30B9_65"
                data-name="\u30D1\u30B9 65"
                className="cls-1"
                d="M320.263 471.114a7.161 7.161 0 10-14.322 0v14.341h3.617v-14.413a3.545 3.545 0 017.089 0V485.455h3.617v-14.322z"
                transform="translate(-219.702 -456.823)"
            />
            <path
                id="\u30D1\u30B9_66"
                data-name="\u30D1\u30B9 66"
                className="cls-2"
                d="M360.182 478.224a7.161 7.161 0 11-14.322 0v-14.195h3.617V478.3a3.545 3.545 0 007.089 0V464.029h3.617v14.177z"
                transform="translate(-220.738 -456.824)"
            />
            <path
                id="\u9577\u65B9\u5F62_4"
                data-name="\u9577\u65B9\u5F62 4"
                className="cls-1"
                transform="translate(19.485 7.003)"
                d="M0 0H3.617V21.609H0z"
            />
            <rect
                id="\u9577\u65B9\u5F62_5"
                data-name="\u9577\u65B9\u5F62 5"
                className="cls-1"
                width={3.617}
                height={3.617}
                rx={1.808}
                transform="translate(19.485)"
            />
            <path
                id="\u30D1\u30B9_67"
                data-name="\u30D1\u30B9 67"
                className="cls-2"
                d="M340.212 470.891a7.16 7.16 0 00-10.706-6.221v-7.958h-3.616v28.446h3.617v-14.339a3.545 3.545 0 017.089 0v14.339h3.617v-14.213c-.002-.018-.001-.036-.001-.054z"
                transform="translate(-220.22 -456.635)"
            />
            <g
                id="\u30B0\u30EB\u30FC\u30D7_7"
                data-name="\u30B0\u30EB\u30FC\u30D7 7"
                transform="translate(144.383 .016)"
            >
                <path
                    id="\u30D1\u30B9_68"
                    data-name="\u30D1\u30B9 68"
                    className="cls-2"
                    d="M379.956 471v-.128a7.159 7.159 0 00-10.7-6.094v-8.128h-3.617v21.383a7.161 7.161 0 0014.322 0v-.018zm-3.617.813v6.149a3.545 3.545 0 01-7.089 0v-7.035a3.545 3.545 0 017.089 0z"
                    transform="translate(-365.634 -456.649)"
                />
            </g>
            <path
                id="\u30D1\u30B9_69"
                data-name="\u30D1\u30B9 69"
                className="cls-1"
                d="M228.193 478.163a3.572 3.572 0 01-7.144 0v-7.143a3.572 3.572 0 017.144 0h3.644a7.216 7.216 0 00-14.432 0v7.18a7.215 7.215 0 0014.43 0h-3.643z"
                transform="translate(-217.405 -456.819)"
            />
            <path
                id="\u30D1\u30B9_70"
                data-name="\u30D1\u30B9 70"
                className="cls-1"
                d="M293.165 463.814a7.216 7.216 0 00-7.216 7.216v7.18a7.215 7.215 0 0014.431 0v-7.18a7.216 7.216 0 00-7.215-7.216zm3.572 8.089v6.269a3.571 3.571 0 11-7.143 0v-7.142a3.571 3.571 0 117.143 0z"
                transform="translate(-219.183 -456.819)"
            />
            <g
                id="\u30B0\u30EB\u30FC\u30D7_8"
                data-name="\u30B0\u30EB\u30FC\u30D7 8"
                transform="translate(47.523 6.995)"
            >
                <path
                    id="\u30D1\u30B9_71"
                    data-name="\u30D1\u30B9 71"
                    className="cls-1"
                    d="M280.626 471.03a7.216 7.216 0 00-14.432 0V478.273a7.216 7.216 0 0014.432 0v-.073h-3.644a3.571 3.571 0 01-7.142-.027V474.7h10.788v-3.644zm-3.646.027h-7.142v-.027a3.571 3.571 0 117.143 0z"
                    transform="translate(-266.194 -463.814)"
                />
            </g>
        </svg>
    );
}
